import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Divider,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const ContactPage = () => {

  return (
    <Box
      sx={{
        minHeight: '100vh',
        pt: 20,
        pb: 6,
        backgroundColor: '#000000',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            textAlign: 'center',
            mb: 8,
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            sx={{
              color: '#FFD700',
              mb: 2,
            }}
          >
            Get in Touch
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: 'rgba(255, 215, 0, 0.7)',
              fontWeight: 300,
            }}
          >
            We'd Love to Hear From You
          </Typography>
        </Box>

        <Grid container spacing={6} justifyContent="center">
          <Grid item xs={12} md={3} sx={{ height: "100%" }}>
            <Box
              onClick={() => window.open("https://maps.app.goo.gl/rYFLDLbW8zhKLVxo9", "_blank")}
              sx={{
                p: 4,
                cursor: "pointer",
                height: "100%",
                textAlign: 'center',
                border: '1px solid rgba(255, 215, 0, 0.2)',
                borderRadius: 2,
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  border: '1px solid rgba(255, 215, 0, 0.5)',
                },
              }}
            >
              <LocationOnIcon sx={{ fontSize: 40, color: '#FFD700', mb: 2 }} />
              <Typography
                variant="h6"
                sx={{
                  color: '#FFD700',
                  mb: 2,
                }}
              >
                Visit Us
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'rgba(255, 215, 0, 0.7)', lineHeight: 1.8 }}
              >
                PT. Acroe Indonesia
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3} sx={{ height: "100%" }}>
            <Box
              onClick={() => window.open("https://wa.me/62816663699", "_blank")}
              sx={{
                p: 4,
                cursor: "pointer",
                height: "100%",
                textAlign: 'center',
                border: '1px solid rgba(255, 215, 0, 0.2)',
                borderRadius: 2,
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  border: '1px solid rgba(255, 215, 0, 0.5)',
                },
              }}
            >
              <WhatsAppIcon sx={{ fontSize: 40, color: '#FFD700', mb: 2 }} />
              <Typography
                variant="h6"
                sx={{
                  color: '#FFD700',
                  mb: 2,
                }}
              >
                Message Us
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'rgba(255, 215, 0, 0.7)', lineHeight: 1.8 }}
              >
                +62 816 663 699
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3} sx={{ height: "100%" }}>
            <Box
              onClick={() => window.open("tel:+62-21-6303-027", "_blank")}
              sx={{
                p: 4,
                cursor: "pointer",
                height: "100%",
                textAlign: 'center',
                border: '1px solid rgba(255, 215, 0, 0.2)',
                borderRadius: 2,
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  border: '1px solid rgba(255, 215, 0, 0.5)',
                },
              }}
            >
              <PhoneIcon sx={{ fontSize: 40, color: '#FFD700', mb: 2 }} />
              <Typography
                variant="h6"
                sx={{
                  color: '#FFD700',
                  mb: 2,
                }}
              >
                Call Us
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'rgba(255, 215, 0, 0.7)', lineHeight: 1.8 }}
              >
                +62 21 6303 027
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3} sx={{ height: "100%" }}>
            <Box
              onClick={() => window.open("mailto:sales.jakarta@acroe.com", "_blank")}
              sx={{
                p: 4,
                cursor: "pointer",
                height: "100%",
                textAlign: 'center',
                border: '1px solid rgba(255, 215, 0, 0.2)',
                borderRadius: 2,
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  border: '1px solid rgba(255, 215, 0, 0.5)',
                },
              }}
            >
              <EmailIcon sx={{ fontSize: 40, color: '#FFD700', mb: 2 }} />
              <Typography
                variant="h6"
                sx={{
                  color: '#FFD700',
                  mb: 2,
                }}
              >
                Email Us
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'rgba(255, 215, 0, 0.7)', lineHeight: 1.8 }}
              >
                sales.jakarta@acroe.com
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: 8,
            p: 4,
            textAlign: 'center',
            border: '1px solid rgba(255, 215, 0, 0.2)',
            borderRadius: 2,
          }}
        >
          <AccessTimeIcon sx={{ fontSize: 40, color: '#FFD700', mb: 2 }} />
          <Typography
            variant="h6"
            sx={{
              color: '#FFD700',
              mb: 2,
            }}
          >
            Business Hours
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: 'rgba(255, 215, 0, 0.7)', lineHeight: 1.8 }}
          >
            Monday - Friday: 9:00 AM - 5:00 PM WIB<br />
            Saturday - Sunday: Closed
          </Typography>
        </Box>

      </Container>
    </Box>
  );
};

export default ContactPage;
